/**
 * Pure platform API path builders for console management surfaces.
 * Kept free of fetch/React so unit tests can assert real route contracts.
 */

export function storageBucketsPath(projectId: string): string {
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/storage/buckets`;
}

export function storageBucketObjectsPath(
  projectId: string,
  bucket: string,
  prefix?: string,
): string {
  const base = `/v1/platform/projects/${encodeURIComponent(projectId)}/storage/buckets/${encodeURIComponent(bucket)}/objects`;
  if (prefix == null || prefix === "") return base;
  return `${base}?prefix=${encodeURIComponent(prefix)}`;
}

export function storageUploadPath(
  projectId: string,
  bucket: string,
  objectPath: string,
): string {
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/storage/buckets/${encodeURIComponent(bucket)}/objects?path=${encodeURIComponent(objectPath)}`;
}

export function storageObjectPath(
  projectId: string,
  bucket: string,
  objectPath: string,
  download = false,
): string {
  const q = new URLSearchParams({ path: objectPath });
  if (download) q.set("download", "1");
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/storage/buckets/${encodeURIComponent(bucket)}/object?${q.toString()}`;
}

export function storageSignPath(projectId: string, bucket: string): string {
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/storage/buckets/${encodeURIComponent(bucket)}/sign`;
}

export function storageSignedDownloadPath(token: string): string {
  return `/v1/storage/download?token=${encodeURIComponent(token)}`;
}

export function imagesPath(projectId: string, query?: { status?: string; visibility?: string; prefix?: string }): string {
  const base = `/v1/platform/projects/${encodeURIComponent(projectId)}/images`;
  if (!query) return base;
  const q = new URLSearchParams();
  if (query.status) q.set("status", query.status);
  if (query.visibility) q.set("visibility", query.visibility);
  if (query.prefix) q.set("prefix", query.prefix);
  const s = q.toString();
  return s ? `${base}?${s}` : base;
}

export function imagePath(projectId: string, imageId: string): string {
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/images/${encodeURIComponent(imageId)}`;
}

export function imageSignedDownloadPath(token: string): string {
  return `/v1/images/download?token=${encodeURIComponent(token)}`;
}

export function impersonateUserPath(
  projectId: string,
  userId: string,
): string {
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/users/${encodeURIComponent(userId)}/impersonate`;
}

export function usageQuotasPath(projectId: string): string {
  return `/v1/platform/projects/${encodeURIComponent(projectId)}/usage/quotas`;
}
